import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';

import { GlassCard } from '@/components/common/glass-card';
import { Text, useTheme } from '@/components/ui';

/** Shared "WO #<n> — <location>" row label for dashboard cards (#48). */
export const workOrderRowLabel = (wo: { orderNumber?: number | null; jobLocation?: string | null }): string => {
	const base = wo.orderNumber ? `WO #${wo.orderNumber}` : 'Work Order';
	return wo.jobLocation ? `${base} — ${wo.jobLocation}` : base;
};

/**
 * Compact dashboard card shell: a GlassCard with an accented icon + title +
 * count badge header, over caller-supplied rows. Shared by FollowUpsCard and
 * the v2 To Do panel so the header/badge styling stays in one place (#48).
 */
export const DashboardSummaryCard: React.FC<{
	testID?: string;
	icon: keyof typeof Ionicons.glyphMap;
	accent: string;
	title: string;
	count: number;
	style?: ViewStyle;
	children: React.ReactNode;
}> = ({ testID, icon, accent, title, count, style, children }) => {
	const theme = useTheme();
	return (
		<View style={style} testID={testID}>
			<GlassCard>
				<View style={styles.header}>
					<Ionicons name={icon} size={18} color={accent} />
					<Text style={[styles.title, { color: theme.colors.onSurface }]}>{title}</Text>
					<View style={[styles.badge, { backgroundColor: accent }]}>
						<Text style={styles.badgeText}>{count}</Text>
					</View>
				</View>
				{children}
			</GlassCard>
		</View>
	);
};

const styles = StyleSheet.create({
	header: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 8,
		marginBottom: 6,
	},
	title: {
		fontSize: 18,
		fontWeight: '700',
	},
	badge: {
		borderRadius: 10,
		minWidth: 22,
		height: 22,
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: 7,
	},
	badgeText: {
		fontSize: 12,
		fontWeight: '700',
		color: '#fff',
	},
});
